import { io } from 'socket.io-client';
import { API_ORIGIN } from '../config/api';

export const createChatSocket = (accessToken) =>
  io(`${API_ORIGIN}/chat`, {
    transports: ['websocket', 'polling'],
    auth: {
      token: `Bearer ${accessToken}`,
    },
  });
